import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import config from '../../config';

const PauseScreenSlideShow = (props) => {
    const sliderRef = useRef(null);
    const slideShow = useSelector(state => state.slideState.slideShows[props.slideShowId]);

    const settings = {
        dots: false,
        autoplay: true,
        swipeToSlide: false,
        autoplaySpeed: 1000 * 10, // 10 seconds
        arrows: false,
        swipe: false,
    };

    const renderSlide = (slide) => (
        <div key={slide.id} className="pause-screen">
            <img className="pause-screen-img" src={config.server + slide.imagePath} alt="" />
        </div>
    );

    const slideComponents = slideShow && slideShow.slides.map((s) => renderSlide(s));

    // Handle fullscreen change events
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (document.fullscreenElement) {
                if (sliderRef.current) {
                    sliderRef.current.slickNext();
                }
            }
        };

        // Add event listener
        document.addEventListener('fullscreenchange', handleFullscreenChange);

        // Cleanup on component unmount
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);

    return (
        <div className={`temp-pause-screen ${props.className || ''}`}>
            <Slider {...settings} ref={sliderRef}>
                {slideComponents}
            </Slider>
        </div>
    );
};

PauseScreenSlideShow.propTypes = {
    slideShowId: PropTypes.number.isRequired,
    className: PropTypes.string,
};
export default PauseScreenSlideShow;